import Vue from "vue";
import Vuex from "vuex";
import { addPanel, getPanel, deletePanel } from "../../utils/apiFunctions.js";
Vue.use(Vuex);
// State
const state = () => ({
  PanelDetails: [],
  selectedCandidate: {},
  filterobject: {
    skills: "",
    expertise: "",
  },
  LoadStatus: false,
});

// getters
const getters = {
  getParticularCandDetails: (state) => state.selectedCandidate,
  getsaveAllPanel: (state) => {
    let filteredPanel = [];
    if (state.filterobject.skills != "" && state.filterobject.expertise == "") {
      filteredPanel = state.PanelDetails.filter((data) => {
        return (
          !state.filterobject.skills ||
          data.skills.some(
            (skills) =>
              skills.name.toLowerCase().valueOf() ===
              state.filterobject.skills.toLowerCase().valueOf()
          )
        );
      });
    } else if (
      state.filterobject.skills == "" &&
      state.filterobject.expertise != ""
    ) {
      filteredPanel = state.PanelDetails.filter((data) => {
        return (
          !state.filterobject.expertise ||
          data.areaOfExpertise.some(
            (aofe) =>
              aofe.name.toLowerCase().valueOf() ===
              state.filterobject.expertise.toLowerCase().valueOf()
          )
        );
      });
    } else if (
      state.filterobject.skills != "" &&
      state.filterobject.expertise != ""
    ) {
      filteredPanel = state.PanelDetails.filter((data) => {
        return (
          (!state.filterobject.skills ||
            data.skills.some(
              (skills) =>
                skills.name.toLowerCase().valueOf() ===
                state.filterobject.skills.toLowerCase().valueOf()
            )) &&
          (!state.filterobject.expertise ||
            data.areaOfExpertise.some(
              (aofe) =>
                aofe.name.toLowerCase().valueOf() ===
                state.filterobject.expertise.toLowerCase().valueOf()
            ))
        );
      });
    } else {
      filteredPanel = state.PanelDetails;
    }
    return filteredPanel;
  },
};

const actions = {
  // POST ADD Vendor API
  async saveAddpanel(state, payload) {
    let data = await payload;
    try {
      const res = await addPanel(data);
      if (res.status == 200) {
        state.commit("savepanel", data);
      }
      return res;
    } catch (error) {
      return error;
    }
  },
  // GET Panel API
  async getPanel(state, data) {
    let type = 1;
    getPanel(type, data)
      .then((res) => {
        if (res.status == 200) {
          let payload = res.data.data;

          state.commit("saveAllPanel", payload);
        }
      })
      .catch((err) => {
        throw err;
      });
  },
  // DELETE Panel API
  async deletePanel(state, payload) {
    let data = await payload;
    try {
      const response = await deletePanel(data);
      if (response.status == 200) {
        state.commit("deletecurrentpanel", payload);
      }
      return response;
    } catch (error) {
      return error;
    }
  },
};
// mutations
const mutations = {
  setSelectedCandidate(state, candidate) {
    state.selectedCandidate = candidate;
  },
  saveLoadStatus(state, payload) {
    state.LoadStatus = payload;
  },
  // add panel
  savepanel(state, payload) {
    state.PanelDetails.push(payload);
  },

  // GET panel
  saveAllPanel(state, payload) {
    state.PanelDetails = payload;
  },

  // EDIT panel
  editcurrpanel(state, payload) {
    for (let i in state.PanelDetails) {
      if (state.PanelDetails[i].panelID === payload.panelID) {
        // Copying the OBJECT
        state.PanelDetails[i] = { ...payload };
      }
    }
  },
  savefilterobject(state, payload) {
    state.filterobject.skills = payload.skills;
    state.filterobject.expertise = payload.expertise;
  },

  // DELETE CUSTOMER
  deletecurrentpanel(state, payload) {
    for (let id of payload.panelID) {
      state.PanelDetails = state.PanelDetails.filter(
        (data) => data.panelID !== id
      );
    }
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
